import Options from '../../Options.esm.js';

var dateMatcher = (() => {
  return {
    warning: Options.translations.warnings.dates,
    suggestions: [Options.translations.suggestions.dates]
  };
});

export { dateMatcher as default };
//# sourceMappingURL=feedback.esm.js.map
